import React from 'react'
import { observer } from 'mobx-react-lite'
import { ISelectorOption } from '@trivie/core'
import { AutocompleteSelector } from '../../../../../components/autocomplete-selector'

interface SurveyAssigneesProps {
  preselectIds?: { id: number; type: string }[]
  defaultOptions?: ISelectorOption[]
  onSelectionChange: (selected: ISelectorOption[]) => void
}

export const SurveyAssignees = observer((props: SurveyAssigneesProps) => {
  const { preselectIds, defaultOptions, onSelectionChange } = props

  return (
    <AutocompleteSelector
      variant="users-groups"
      open
      preselectIds={preselectIds}
      defaultOptions={defaultOptions}
      onSelectionChange={onSelectionChange}
    />
  )
})
